import React, { Component } from 'react'

import moment from 'moment'
import Validation from 'react-validation'
import ReactSelect from 'react-select'
import NkmDatepicker from 'nkm-datepicker'
import _ from 'lodash'


import { FormGroup, ControlLabel, Row, Col, Modal } from 'react-bootstrap'

import Repository from '../../felles/repository'
import { resolve } from '../../dependencies'

import 'react-select/dist/react-select.css'
import 'react-datetime/css/react-datetime.css'
import './arbeidslistemodal.css'

import 'nka-input-number/dist/style.css'
import 'nkm-datepicker/dist/style.css'
import '../../felles/valideringsRegler'




moment.locale('nb')

export default class NyArbeidsliste extends Component {

    constructor(props) {
        super(props)
        this.state = {
            tittel: '',
            beskrivelse: '',
            feilMelding: '',
            startdato: this.props.planlagtdato ? moment(this.props.planlagtdato) : moment(),
            startTidspunkt: this.props.starttidspunkt ? this.props.starttidspunkt : '08:00',
            sluttTidspunkt: this.props.sluttidspunkt ? this.props.sluttidspunkt : '16:00',
            endreArbeidsliste: false,
            brukere: [],
            valgteBrukere: '',
            id: null
        }
        this._submit = this._submit.bind(this)
        this._handleEndretVerdi = this._handleEndretVerdi.bind(this)
        this._handleSelectChange = this._handleSelectChange.bind(this)
        this._handleStartdatoEndret = this._handleStartdatoEndret.bind(this)
    }

    componentDidMount() {
        resolve(Repository).hentBrukere().then(liste => this.setState({
            brukere: liste,
            tittel: this.props.tittel,
            beskrivelse: this.props.beskrivelse ? this.props.beskrivelse : '',
            id: this.props.id,
            valgteBrukere: this.props.tilknytteteBrukere ? this.props.tilknytteteBrukere : ''
        }))        
    }

    _submit = (event) => {
        event.preventDefault()

        let arbeidsliste = {
            Tittel: this.state.tittel,
            Beskrivelse: this.state.beskrivelse,
            Startdato: moment(new Date(this.state.startdato)).format("YYYY-MM-DD"),
            StartTidspunkt: this.state.startTidspunkt,
            SluttTidspunkt: this.state.sluttTidspunkt,
            ValgteBrukerIder: _.map(this.state.valgteBrukere, _.property('BrukerGUID')),
            Id: this.props.id
        };
        
        this.props.onLagtTilArbeidsliste(arbeidsliste, this.props.endreArbeidsliste)
    }

    _handleStartdatoEndret(dato) {
        this.setState({
            startdato: dato
        })
    }

    _handleEndretVerdi(data) {
        const verdi = data.target.value
        const navn = data.target.name

        this.setState({
            [navn]: verdi
        });
    }

    _handleSelectChange(value) {        
        this.setState({
            valgteBrukere: value
        });
    }

    render() {
        
        return (
            <Modal show={this.props.isOpen} onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {
                            this.state.id ? 'Endre arbeidsliste' : 'Ny arbeidsliste'
                        }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Validation.components.Form ref={c => this.form = c} onSubmit={this._submit}>
                        <Row>
                            <Col sm={12}>
                                <FormGroup controlId="formBasicText" >
                                    <ControlLabel>Navn*</ControlLabel>
                                    <Validation.components.Input
                                        errorClassName='is-invalid-input'
                                        type="text"
                                        className="form-control"
                                        value={this.state.tittel}
                                        placeholder="Navn på arbeidsliste"
                                        name="tittel"
                                        validations={['required', 'mindreEnn50Tegn']} onChange={this._handleEndretVerdi}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={12}>
                                <FormGroup
                                    controlId="formbeskrivelseText">
                                    <ControlLabel>Beskrivelse</ControlLabel>
                                    <Validation.components.Textarea
                                        errorClassName='is-invalid-input'
                                        cols="4"
                                        value={this.state.beskrivelse}
                                        placeholder="Beskrivelse på arbeidsliste"
                                        onChange={this._handleEndretVerdi}
                                        validations={['mindreEnn512Tegn']}
                                        name="beskrivelse"
                                        className="form-control"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={12}>
                                <FormGroup>
                                    <ControlLabel>Velg utførende rørlegger(e)</ControlLabel>
                                    <ReactSelect
                                        multi
                                        id="ans"
                                        valueKey="BrukerGUID"
                                        labelKey="Navn"                                        
                                        options={this.state.brukere}
                                        onChange={this._handleSelectChange}
                                        placeholder="Rørlegger(e) som skal jobbe på arbeidslisten"
                                        value={this.state.valgteBrukere} />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={5} >
                                <FormGroup>
                                    <ControlLabel>Planlagt fra</ControlLabel>
                                    <NkmDatepicker
                                        timeFormat={false} dateFormat="DD.MM.YYYY"
                                        defaultValue={this.state.startdato}
                                        onChange={this._handleStartdatoEndret}
                                        closeOnSelect={true} />

                                </FormGroup>
                            </Col>
                            <Col sm={3} >
                                <FormGroup>
                                    <ControlLabel>Fra tidspunkt</ControlLabel>
                                    <input type="time"    className="nka-input-number nka-input-numberwhite" name="startTidspunkt" value={this.state.startTidspunkt}
                                        onChange={this._handleEndretVerdi} min="01:00" max="23:00" />
                                </FormGroup>
                            </Col>

                            <Col sm={3} >
                                <FormGroup>
                                    <ControlLabel>Til tidspunkt</ControlLabel>
                                    <input type="time"     className="nka-input-number nka-input-numberwhite" name="sluttTidspunkt" value={this.state.sluttTidspunkt}
                                        onChange={this._handleEndretVerdi} min="01:00" max="23:00" />

                                </FormGroup>
                            </Col>
                        </Row>

                        <Validation.components.Button className="btn btn-primary" >OK</Validation.components.Button>

                    </Validation.components.Form>
                </Modal.Body>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/planlegging/arbeidsliste/arbeidslistemodal.jsx